import { useCallback, useEffect, useState } from 'react';
import { api } from '../../api';
import type { HuntOrder } from '../../api/types';

/**
 * Ordem de caçada: trava lojas, banco e ofícios. Recarrega na troca de mapa e no aviso "HuntFim" do servidor. `fora`: a caçada seguiu com a aba
 * fechada e o resumo espera o jogador (techspec-cacada-venda §06) — o mundo abre a janela de Caçadas.
 */
export function useCacadaAtiva(mapaId: string | undefined, fimSeq = 0) {
  const [ordem, setOrdem] = useState<HuntOrder | null>(null);
  const [fora, setFora] = useState(false);

  const buscar = useCallback(async () => {
    try {
      const board = await api.getHunts();
      setOrdem(board.ordem);
      setFora(!!board.fora);
    } catch {
      /* a ordem anterior segura o cadeado */
    }
  }, []);

  // `fimSeq`: o servidor avisou que a ordem acabou ("HuntFim"). Cancelar ainda na cidade não troca de mapa.
  useEffect(() => { void buscar(); }, [buscar, mapaId, fimSeq]);

  return { ordem, setOrdem, cacando: ordem !== null, fora };
}
